module.exports = __webpack_public_path__ + "media/images/emblems/La_Verrerie-coat_of_arms-da2be3dcf0baf73a8380af1e2951b8f5.svg";